/** A page of the site. */
export interface RouteInfo {
  /** URL path. */
  path: string
  /** Whether search engines may index it: listed in the sitemap, canonical link instead of `noindex`. */
  indexed: boolean
}

/**
 * Every page of the site. The router, the sitemap and the list of paths nginx
 * answers with 200 (anything else is a real 404) are all built from it.
 */
export const ROUTES = {
  chat: { path: '/', indexed: false },
  login: { path: '/login', indexed: true },
  register: { path: '/register', indexed: true },
  resetPassword: { path: '/reset-password', indexed: false },
  account: { path: '/account', indexed: false },
  moderation: { path: '/moderation', indexed: false },
  terms: { path: '/terms', indexed: true },
  privacy: { path: '/privacy', indexed: true },
} as const satisfies Record<string, RouteInfo>

/** Name of a page in {@link ROUTES}. */
export type RouteName = keyof typeof ROUTES

/** Public address of the site, for canonical links and the sitemap. */
export const SITE_URL = 'https://t.armx.be'
